import React from 'react';
import { IValidationToastNotification } from '../../common';
import { IconType, MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export interface IReservedWarningProps extends IValidationToastNotification {
  serialNo: string;
  message: string;
}

export const ReservedWarning = (props: IReservedWarningProps) => {
  let state = '';
  switch (props.message) {
    case 'VehicleSold':
      state = 'solgt';
      break;
    case 'AlreadyReserved':
      state = 'reservert';
      break;
    default:
      state = 'utilgjengelig';
  }
  return (
    <MessageBar
      severity={TMessageBarSeverity.ERROR}
      onClose={props?.onClose}
      dismissible
      alertIcon={{ icon: IconType.NewNextWarningSolid, size: 32 }}
      className="w-[40rem] border-0 py-8 gap-6 rounded-lg [&_.tw-dismiss-button]:-top-4"
    >
      <h4 className="text-lg/[175%]">{`Denne bilen er ${state}`}</h4>
      <p className="text-base/[175%] font-semibold">{props.serialNo ?? ''} er ikke tilgjengelig.</p>
    </MessageBar>
  );
};
